export function validatePositiveNumber(rule, value, callback) {
    let positiveNumber = /^[0-9]*[1-9][0-9]*$/;
    setTimeout(() => {
        if (!positiveNumber.test(value)) {
            return callback("请输入正整数");
        } else {
            callback();
        }
    }, 100);
}

export function validateEmail(rule, value, callback) {
    let email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    if (value) {
        setTimeout(() => {
            if (!email.test(value)) {
                return callback("邮箱格式错误");
            } else {
                callback();
            }
        }, 100);
    } else {
        callback();
    }
}
export const validator = {
    required: function (value) {
        /// <summary>验证必填</summary>
        if (!value) {
            return false;
        }
        return value.replace(/(^\s*)|(\s*$)/g, "") != "";
    },
    date: function (value) {
        /// <summary>验证日期格式</summary>
        return /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/.test(value);
    },
    dateTime: function (value) {
        /// <summary>验证日期时间格式</summary>
        return (
            /^(\d+)-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/.test(value) ||
            /^(\d+)\/(\d{1,2})\/(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/.test(value)
        );
    },
    mobileNo: function (value) {
        /// <summary>验证手机号格式</summary>
        return /^1\d{10}$/.test(value);
    },
    email: function (value) {
        /// <summary>验证邮箱格式</summary>
        return /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value);
    },
    userCode: function (value) {
        /// <summary>验证用户名复杂度格式</summary>
        return /^[a-zA-z_\-\w]{4,20}$/.test(value);
    },
    passWord: function (value) {
        /// <summary>验证密码复杂度格式</summary>
        return /^((?=.*[`~!@#$%^&*()_+}{|}[\]:?><.])?(?=.*[a-zA-Z]+)(?=.*[0-9]+)).{6,20}$/.test(value);
    },
    number: function (value, decimal, canZero) {
        /// <summary>验证数字格式</summary>
        /// <param name="selector" type="Object">文本框控件选择器或者值</param>
        /// <param name="decimal" type="Number">[可选]允许的最大小数位数，默认不验证</param>
        /// <param name="canZero" type="Boolean">[可选]是否允许为零，默认允许</param>
        if (!value) {
            return false;
        }
        while (value.indexOf(",") >= 0 || value.indexOf("%2C") >= 0) {
            value = value.replace(",", "");
            value = value.replace("%2C", "");
        }
        if (!/^(\d+|\d+\.\d*)$/.test(value)) {
            return false;
        }
        if (canZero == false && this.ConvertNumber(value) == 0) {
            return false;
        }
        if (typeof decimal != "undefined") {
            if (decimal && decimal > -1) {
                if (decimal == 0) {
                    if (value.indexOf(".") > -1) {
                        return false;
                    }
                } else {
                    if (value.indexOf(".") > -1 && value.indexOf(".") < value.length - decimal - 1) {
                        return false;
                    }
                }
            } else if (value.indexOf(".") > -1) {
                return false;
            }
        }
        return true;
    },
};
